// extracted by mini-css-extract-plugin
export default {"catalogHeadline":"catalog_content_catalogHeadline__uua7d","catalogView":"catalog_content_catalogView__VhRS8"};